import React from 'react';
import { Link } from 'react-router-dom';
import footer from '../../../images/footer.png';


const Footer = () => {


    const today = new Date();
    const year = today.getFullYear();


    return (
        <footer style={{
            background: `url(${footer})`,
            backgroundSize: 'cover'
        }} className=" p-10">
            <div className='footer'>
                <div>
                    <span className="footer-title">Services</span>
                    <Link to='' className="link link-hover ">Branding</Link>
                    <Link to='' className="link link-hover ">Design</Link>
                    <Link to='' className="link link-hover ">Marketing</Link>
                    <Link to='' className="link link-hover ">Advertisement</Link>
                </div>
                <div>
                    <span className="footer-title">Company</span>
                    <Link to='' className="link link-hover ">About us</Link>
                    <Link to='' className="link link-hover ">Contact</Link>
                    <Link to='' className="link link-hover ">Jobs</Link>
                    <Link to='' className="link link-hover ">Press kit</Link>
                </div>
                <div>
                    <span className="footer-title">Legal</span>
                    <Link to='' className="link link-hover ">Terms of use</Link>
                    <Link to='' className="link link-hover ">Privacy policy</Link>
                    <Link to='' className="link link-hover ">Cookie policy</Link>
                </div>
            </div>
            <div className='mt-16 text-center'>
                <p>Copyright © {year} - Home Depot Manufacturer LTD.</p>
            </div>
        </footer>
    );
};

export default Footer;